import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Dropdown, Form } from "react-bootstrap";
import { BusinessChartComponent } from "../charts";

export default function BusinessCardComponent({ businessTypes }) {
  const { t } = useContext(TranslatorContext);

  const [filter, setFilter] = useState({
    filter: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="mc-card">
      <div className="mc-card-header">
        <h4 className="mc-card-title">
          {t("Rescued Families Business Startups")}
        </h4>
        <Dropdown bsPrefix="mc-dropdown">
          <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
            <i className="material-icons">more_horiz</i>
          </Dropdown.Toggle>
          <Dropdown.Menu
            align="end"
            className="mc-dropdown-paper"
            style={{ width: "268px" }}
          >
            <Form.Group className="w-sm h-sm">
              <Form.Select name="filter" value={filter.filter} onChange={handleChange}>
                <option value="">Select Request ID</option>
              </Form.Select>
            </Form.Group>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* 🛡️ Safe rendering: */}
      <BusinessChartComponent businessTypes={businessTypes || []} />
    </div>
  );
}
